import React from 'react';
import './css/login.css'
import theme from './temaConfig'
import {ThemeProvider} from '@material-ui/styles'
import Contenedor from './components/contenedor';
import Login from './components/login';
import LoginMedic from './components/LoginMedisas';

function App() {
  const [logged, setLogged] = React.useState(false);
  const [user, setUser] = React.useState({id:''});
  return (
    <ThemeProvider theme={theme}>
      {logged ? <Contenedor user={user}></Contenedor> :
      <LoginMedic setLogged={setLogged} setUser={setUser}></LoginMedic>}
    </ThemeProvider>
  );
}

export default App;
